<p-panel>
	<app-reactive-form-builder
		#builderRef
		(stableValueChanges)="stableValueChanges($event)"
		(goBack)="goBack()"
		[form]="form.formFields"
		[id]="reactiveFormRecordId"
		[request]="request"
		[getRequest]="entidadesApi.EntidadesGET"
	>
	</app-reactive-form-builder>
</p-panel>
